import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

import 'tablesaw/dist/tablesaw.jquery';
import libs from './lib/dependancies';
window.libs = libs;

import Spotlight from 'spotlight.js'

$(document).foundation();

libs.AOS.init();

// SVG Injector
// Elements to inject
var mySVGsToInject = document.querySelectorAll('img.inject-me');

// Options
var injectorOptions = {
  evalScripts: 'once',
  pngFallback: 'assets/png'
};

var afterAllInjectionsFinishedCallback = function (totalSVGsInjected) {
  // Callback after all SVGs are injected
  console.log('We injected ' + totalSVGsInjected + ' SVG(s)!');
};

var perInjectionCallback = function (svg) {
  // Callback after each SVG is injected
  console.log('SVG injected: ' + svg);
};

// create injector configured by options
var injector = new libs.svgInjector(injectorOptions);

// Trigger the injection
injector.inject(
  mySVGsToInject,
  afterAllInjectionsFinishedCallback,
  perInjectionCallback
);

// slick carousel
$(".content-carousel").slick({
  // normal options...
  speed: 5000,
	autoplay: true,
	autoplaySpeed: 0,
	cssEase: 'linear',
  slidesToShow: 5,
	slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
	centerMode: true,
  focusOnSelect: true,
  // the magic
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: true
      }
    }, {
      breakpoint: 300,
      settings: "unslick" // destroys slick
    }]
});

// tablesaw table plugin
$(function () {
  $(document)
    .foundation()
    .trigger('enhance.tablesaw');
});

var TablesawConfig = {
  swipeHorizontalThreshold: 15
};

// app dashboard toggle
$('[data-app-dashboard-toggle-shrink]').on('click', function(e) {
  e.preventDefault();
  $(this).parents('.app-dashboard').toggleClass('shrink-medium').toggleClass('shrink-large');
});

// BEGIN FORM VALIDATE
const MAXWORDS = 250

// Disable native form validation
const formPovzetek = document.getElementsByName('formPovzetek')[ 0 ]
if (formPovzetek) {
  formPovzetek.setAttribute('novalidtate', true)
}

const formPrijava = document.getElementsByName('formPrijava')[ 0 ]
if (formPrijava) {
  formPrijava.setAttribute('novalidate', true)
}


let spanMaxWords = document.getElementsByClassName('maxWords')
if (spanMaxWords) {
  for (let i = 0; i < spanMaxWords.length; i++) {
    spanMaxWords[i].innerText = MAXWORDS
  }
}

let povzetek

if (formPovzetek) {

  let avtor1 = document.getElementById('avtor1');
  let avtor2 = document.getElementById('avtor2');
  let avtor3 = document.getElementById('avtor3');
  let avtor4 = document.getElementById('avtor4');
  let avtor5 = document.getElementById('avtor5');

  let avtor2Container = document.getElementById('avtor2Container');
  avtor2Container.style.display = "none";

  let avtor3Container = document.getElementById('avtor3Container');
  avtor3Container.style.display = "none";

  let avtor4Container = document.getElementById('avtor4Container');
  avtor4Container.style.display = "none";

  let avtor5Container = document.getElementById('avtor5Container');
  avtor5Container.style.display = "none";

  avtor1.addEventListener('input', function () {
    avtor2Container.style.display = "block";
  })
  avtor2.addEventListener('input', function () {
    avtor3Container.style.display = "block";
  })
  avtor3.addEventListener('input', function () {
    avtor4Container.style.display = "block";
  })
  avtor4.addEventListener('input', function () {
    avtor5Container.style.display = "block";
  })


  povzetek = document.getElementsByName('povzetek')[ 0 ]
}

let characterCount = document.querySelector('#chars')
let wordCount = document.querySelector('#words')
let ignoreKeys = [ 8, 9, 13, 32, 46 ]

let poslji = document.getElementsByName('poslji')
poslji.disabled = true

// if (formPovzetek) {
//   let characterCount = document.querySelector('#chars')
//   let wordCount = document.querySelector('#words')
//   let ignoreKeys = [ 8, 9, 13, 32, 46 ]
// }


console.clear()

function wordCounter(text) {
  var resultArray = [];
  var str = text.replace(/[\t\n\r\.\?\!]/gm,' ')
  var wordArray = str.split(" ")
  for (var i = 0; i < wordArray.length; i++) {
    var item = wordArray[i].trim()
    if (item.length > 0) {
      resultArray.push(item)
    }
  }
  return resultArray
}

if (povzetek) {

  povzetek.addEventListener('keyup', function (e) {
    e.preventDefault()
    e.stopPropagation()

    //var words = povzetek.value.match(/\b[-?(\w+)?]+\b/gi);
    //var words = povzetek.value.match(/\S+/gi);
    var words = wordCounter(povzetek.value)
    var chars = povzetek.value.match(/[^\s*]/g);

    if (chars) {
      characterCount.innerHTML = chars.length
    } else {
      characterCount.innerHTML = 0
    }

    if (words) {
      wordCount.innerHTML = words.length
      if (words.length > MAXWORDS) {
        wordCount.style.color = 'red'
        povzetek.style.borderColor = 'red'
      } else {
        wordCount.style.color = 'green'
        povzetek.style.borderColor = '#cacaca'
      }
    } else {
      wordCount.innerHTML = 0;
      wordCount.style.color = 'green'
      povzetek.style.borderColor = '#cacaca'
    }
  })

  povzetek.addEventListener('paste', (e) => {
    // e.preventDefault()
    // e.stopPropagation()

    let paste = (e.clipboardData || window.clipboardData).getData('text')

    // var words = paste.match(/\b[-?(\w+)?]+\b/gi)
    var words = wordCounter(paste)

    if (words.length > MAXWORDS ) {
      alert('Besedilo, ki ga želite prilepiti je daljše od ' + MAXWORDS + ' besed!')
    }
    else {
      povzetek.focus()
      //povzetek.select()
      document.execCommand('Paste')
    }

    var chars = povzetek.value.match(/[^\s*]/g);
    if (chars) {
      characterCount.innerHTML = chars.length
    } else {
      characterCount.innerHTML = 0
    }
    // console.log(words);

    if (words) {
      wordCount.innerHTML = words.length
      if (words.length > MAXWORDS) {
        wordCount.style.color = 'red'
        povzetek.style.borderColor = 'red'
      } else {
        wordCount.style.color = 'green'
        povzetek.style.borderColor = '#cacaca'
      }
    } else {
      wordCount.innerHTML = 0;
      wordCount.style.color = 'green'
      povzetek.style.borderColor = '#cacaca'
    }
  })
}


document.addEventListener('blur', function (event) {
  // Only run if the field is in a form to be validated
  if (!event.target.form.classList.contains('validate')) return

  // Validate the field
  var error = hasError(event.target);

  if (error) {
    showError(event.target, error)
    return
  }
  removeError(event.target)
}, true)


// showError
let showError = function (field, error) {

  // Add error class to field for styling
  field.classList.add('error')

  // If the field is a radio button and part of a group, error all and get the last item in the group
  if (field.type === 'radio' && field.name) {
    let group = document.getElementsByName(field.name)
    if (group.length > 0) {
      for (let i = 0; i < group.length; i++) {
        // Only check fields in current form
        if (group[ i ].form !== field.form) continue
        group[i].classList.add('error')
      }
      field = group[group.length - 1]
    }
  }

  // Get field id or name
  var id = field.id || field.name
  if (!id) return

  var message = field.form.querySelector('.error-message#error-for-' + id)
  if (!message) {
    var message = document.createElement('div')
    message.className = 'error-message'
    message.id = 'error-for-' + id

    var label;
    if (field.type === 'radio' || field.type ==='checkbox') {
        label = field.form.querySelector('label[for="' + id + '"]') || field.parentNode;
        if (label) {
            label.parentNode.insertBefore( message, label.nextSibling );
        }
    }

    // Otherwise, insert it after the field
    if (!label) {
        field.parentNode.insertBefore( message, field.nextSibling );
    }

    // field.parentNode.insertBefore( message, field.nextSibling );
    field.parentNode.parentNode.insertBefore( message, null );
  }

  field.setAttribute('aria-describedby', 'error-for-' + id)

  // Update error message
  message.innerHTML = error
  message.style.display = 'block'
  message.style.visibility = 'visible '
}

// hideError
let removeError = function (field) {

  // remove error class from field
  field.classList.remove('error')

  // If the field is a radio button and part of a group, remove error from all and get the last item in the group
  if (field.type === 'radio' && field.name) {
    var group = document.getElementsByName(field.name);
    if (group.length > 0) {
        for (var i = 0; i < group.length; i++) {
            // Only check fields in current form
            if (group[i].form !== field.form) continue;
            group[i].classList.remove('error');
        }
        field = group[group.length - 1];
    }
  }
  // Remove ARIA role from the field
  field.removeAttribute('aria-describedby')

  // Get field id or name
  const id = field.id || field.name
  if (!id) return

  // Check if an error message id in the DOM
  var message = field.form.querySelector('.error-message#error-for-' + id)
  if (!message) return

  // If so, hide it
  message.innerHTML = ''
  message.style.display = 'none'
  message.style.visibility = 'hidden'
}

document.addEventListener('submit', function (event) {
  // Only run on forms flagged for validation
  // event.preventDefault();
  //event.stopImmediatePropagation();

  if (!event.target.classList.contains('validate')) return;

  // Get all of the form elements
  var fields = event.target.elements

  // Validate each field
  // Store the first field with an error to a variable so we can bring it into focus later
  var error, hasErrors;
  for (var i = 0; i < fields.length; i++) {
      error = hasError(fields[i]);
      if (error) {
          showError(fields[i], error);
          if (!hasErrors) {
              hasErrors = fields[i];
          }
      }
  }

  // If there are errrors, don't submit form and focus on first element with error
  if (hasErrors) {
      event.preventDefault();
      hasErrors.focus();
  }

  // Otherwise, let the form submit normally
  // You could also bolt in an Ajax form submit process here
}, false)

let hasError = function (field) {
  // Don't validate submits, buttons, file and reset inputs, and disabled fields
  if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

  let specialCheck = true

  // Get validity
  var validity = field.validity

  // Special checks not handled by HTML5
  // Povzetek - največ 250 besed
  if (field.name === 'povzetek') {
    if (wordCounter(field.value).length > MAXWORDS) specialCheck = true
  }

  // If valid, return null
  if (validity.valid && specialCheck) {
    poslji.disabled = false;
    return;
  }

  // If field is required and empty
  if (validity.valueMissing) {
    if (field.name === 'izjava') {
      return 'Če se ne strinjate z izjavo, oddaja povzetka ni možna. Podatki na tem obrazcu so potrebni (obvezni) za objavo v publikaciji.'
    } else {
      return 'To je obvezno polje.'
    }
  }

  // If not the right type
  if (validity.typeMismatch) {

    // Email
    if (field.type === 'email') return 'Vpišite e-poštni naslov.';

    // URL
    if (field.type === 'url') return 'Vpišite URL naslov.';

  }

  // If too short
  if (validity.tooShort) return 'Please lengthen this text to ' + field.getAttribute('minLength') + ' characters or more. You are currently using ' + field.value.length + ' characters.';

  // If too long
  if (validity.tooLong) return 'Please shorten this text to no more than ' + field.getAttribute('maxLength') + ' characters. You are currently using ' + field.value.length + ' characters.';

  // If number input isn't a number
  if (validity.badInput) return 'Please enter a number.';

  // If a number value doesn't match the step interval
  if (validity.stepMismatch) return 'Please select a valid value.';

  // If a number field is over the max
  if (validity.rangeOverflow) return 'Please select a value that is no more than ' + field.getAttribute('max') + '.';

  // If a number field is below the min
  if (validity.rangeUnderflow) return 'Please select a value that is no less than ' + field.getAttribute('min') + '.';

    // If pattern doesn't match
  if (validity.patternMismatch) {

    // If pattern info is included, return custom error
    if (field.hasAttribute('title')) return field.getAttribute('title');

    // Otherwise, generic error
    return 'Please match the requested format.';

  }

  // If all else fails, return a generic catchall error
  return 'The value you entered for this field is invalid.';

}